import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import Index from "./pages/Index.tsx";
import NotFound from "./pages/NotFound.tsx";
import PracticeAreas from "./pages/PracticeAreas.tsx";
import Industries from "./pages/Industries.tsx";
import HighStakes from "./pages/HighStakes.tsx";
import Intelligence from "./pages/Intelligence.tsx";
import MergerRiskRadar from "./pages/MergerRiskRadar.tsx";
import EnforcementIndex from "./pages/EnforcementIndex.tsx";
import StrategyBriefings from "./pages/StrategyBriefings.tsx";
import MarketStructure from "./pages/MarketStructure.tsx";
import RepresentativeIssues from "./pages/RepresentativeIssues.tsx";
import Insights from "./pages/Insights.tsx";
import ClientPortal from "./pages/ClientPortal.tsx";
import Contact from "./pages/Contact.tsx";
import Auth from "./pages/Auth.tsx";
import ResetPassword from "./pages/ResetPassword.tsx";
import About from "./pages/About.tsx";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/practice-areas" element={<PracticeAreas />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/high-stakes" element={<HighStakes />} />
          <Route path="/intelligence" element={<Intelligence />} />
          <Route path="/merger-risk-radar" element={<MergerRiskRadar />} />
          <Route path="/enforcement-index" element={<EnforcementIndex />} />
          <Route path="/strategy-briefings" element={<StrategyBriefings />} />
          <Route path="/market-structure" element={<MarketStructure />} />
          <Route path="/representative-issues" element={<RepresentativeIssues />} />
          <Route path="/insights" element={<Insights />} />
          <Route path="/client-portal" element={<ClientPortal />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
